import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ConsentCheckboxes Component
 * 
 * Standardized consent form matching legal requirements.
 * Both checkboxes are OPTIONAL - form can submit without either checked.
 * 
 * Props:
 * - marketingConsent: boolean
 * - setMarketingConsent: function
 * - nonMarketingConsent: boolean  
 * - setNonMarketingConsent: function
 */
const ConsentCheckboxes = ({ 
  marketingConsent, 
  setMarketingConsent, 
  nonMarketingConsent, 
  setNonMarketingConsent 
}) => {
  return (
    <div className="space-y-4 text-sm">
      {/* Optional: Marketing Messages Checkbox */}
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={marketingConsent}
          onChange={(e) => setMarketingConsent(e.target.checked)}
          className="mt-1 w-4 h-4 rounded border-[#1a4d8c] bg-[#1a2d47] text-[#ff6b35] focus:ring-[#ff6b35] focus:ring-offset-0"
          data-testid="marketing-consent-checkbox"
        />
        <span className="text-[#a8b8d0]">
          <span className="text-[#64748b]">Optional:</span> I want to receive marketing text messages on the phone number provided.
        </span>
      </label>

      {/* Optional: Non-Marketing Messages Checkbox */}
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={nonMarketingConsent}
          onChange={(e) => setNonMarketingConsent(e.target.checked)}
          className="mt-1 w-4 h-4 rounded border-[#1a4d8c] bg-[#1a2d47] text-[#ff6b35] focus:ring-[#ff6b35] focus:ring-offset-0"
          data-testid="non-marketing-consent-checkbox"
        />
        <span className="text-[#a8b8d0]">
          <span className="text-[#64748b]">Optional:</span> I want to receive non marketing messages, including updates and news, on the phone number provided.
        </span>
      </label>

      {/* Divider */}
      <div className="border-t border-[#1a4d8c] my-4"></div>

      {/* Disclaimer Text - Dealership name, message frequency, rates */}
      <div className="text-[#a8b8d0] space-y-3">
        <p>
          By checking the boxes above, I consent to receive marketing and/or non-marketing text messages from We Have Your Car at the phone number provided. Message frequency may vary. Message and data rates may apply.
        </p>
        <p>
          Reply HELP for help or STOP to opt-out.
        </p>
      </div>

      {/* Submit Disclaimer - Terms of Service and Privacy Policy */}
      <p className="text-[#a8b8d0]">
        By submitting this request, I accept the{' '}
        <Link to="/sms-terms" className="text-[#ff6b35] hover:underline">
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link to="/privacy-policy" className="text-[#ff6b35] hover:underline">
          Privacy Policy
        </Link>.
      </p>
    </div>
  );
};

export default ConsentCheckboxes;
